export const state = {
    log: {},
    logs: {
        current_page: 1,
        last_page: 1,
        data: []
    },
    logFiltros: {
        descricao: '',
        data: '',
        funcionarioId: '',
        limit: 5,
        current_page: 1,
        page: 1
    },
}

export default {}